import React, { useRef } from 'react';
import Plot from 'react-plotly.js';
import { Alert } from 'react-bootstrap';
import Plotly from 'plotly.js/dist/plotly'
import PropTypes from 'prop-types';

const PieChartComponent = ({ data = [], dataNamesLabel, dataValuesLabel, isDataAvailable, legendNewlabels, width = '100%', height = '100%' }) => {

    const insertLineBreak = (label) => {
        if (typeof label !== "string" || label?.length <= 25) return label;

        const middle = Math.floor(label.length / 2);
        const spaceBefore = label.lastIndexOf(' ', middle);
        const spaceAfter = label.indexOf(' ', middle);

        let breakIndex;

        // Find the space closest to the centre of the string
        if (spaceBefore === -1 && spaceAfter === -1) {
            breakIndex = middle;
        } else if (spaceBefore === -1) {
            breakIndex = spaceAfter;
        } else if (spaceAfter === -1) {
            breakIndex = spaceBefore;
        } else {
            breakIndex = (middle - spaceBefore < spaceAfter - middle) ? spaceBefore : spaceAfter;
        }

        return label.slice(0, breakIndex) + "<br>" + label.slice(breakIndex + 1);
    }

    const legends = data.map((item) => insertLineBreak(legendNewlabels ? legendNewlabels[item[dataNamesLabel]] ?? legendNewlabels[""] : item[dataNamesLabel]));
    const values = data.map((item) => item[dataValuesLabel]);
    const totalValue = values.reduce((acc, curr) => acc + curr, 0);

    const graphRef = useRef(null);

    const handleLegendClick = (event) => {
        let hiddenLegends = event?.layout?.hiddenlabels ? [...event.layout.hiddenlabels] : [];
        if (!hiddenLegends.includes(event?.label)) {
            hiddenLegends?.push(event?.label);
        } else {
            hiddenLegends = hiddenLegends?.filter(item => item !== event?.label);
        }
        const visibleLegends = legends?.filter(c => !hiddenLegends.includes(c));
        const newTotal = data?.filter(item => visibleLegends?.includes(legendNewlabels
            ? legendNewlabels[item[dataNamesLabel]]
            : item[dataNamesLabel]))
            ?.map((item) => item[dataValuesLabel])
            ?.reduce((acc, curr) => acc + curr, 0);
        if (graphRef.current?.el) {
            Plotly.relayout(graphRef.current.el, {
                'annotations[0].text': `${newTotal}`,
            });
        }
    }

    return isDataAvailable
        ? data?.length > 0
            ? <div>
                <div style={{ width, height, zIndex: "1", minHeight: '30em' }}>
                    <Plot
                        ref={graphRef}
                        data={[
                            {
                                values,
                                labels: legends,
                                type: 'pie',
                                hole: 0.4,
                                textinfo: 'none',
                                hoverinfo: 'label+value+percent',
                                hoverlabel: {
                                    bgcolor: 'white',
                                    bordercolor: 'black',
                                },
                            }
                        ]}
                        style={{ width, height }}
                        layout={{
                            annotations: [
                                {
                                    font: {
                                        size: 20,
                                        color: '#000',
                                    },
                                    showarrow: false,
                                    text: `${totalValue}`,
                                    x: 0.5,
                                    y: 0.5,
                                },
                            ],
                        }}
                        onLegendClick={(event) => handleLegendClick(event)}
                    />
                </div>
            </div>
            : <Alert variant="warning">Aucune donnée à afficher</Alert>
        : <Alert variant="danger">Donnée non disponible</Alert>;
}

PieChartComponent.propTypes = {
    data: PropTypes.array.isRequired,
    dataNamesLabel: PropTypes.string.isRequired,
    dataValuesLabel: PropTypes.string.isRequired,
    isDataAvailable: PropTypes.bool.isRequired,
    legendNewlabels: PropTypes.object,
    width: PropTypes.string,
    height: PropTypes.string,
};

export default PieChartComponent;
